import moment from "moment-timezone";

export const toDate = (value) => (value ? new Date(`${value}T00:00:00`) : null);

export const toValue = (date) =>
  date instanceof Date && !Number.isNaN(date.getTime())
    ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`
    : "";

const MONTHS = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];

function buildDate(year, monthIndex, day) {
  const date = new Date(year, monthIndex, day);
  if (date.getFullYear() !== year || date.getMonth() !== monthIndex || date.getDate() !== day) return null;
  return date;
}

export function parseDateInput(input) {
  const text = String(input ?? "").trim();
  if (text === "") return null;

  const iso = text.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
  if (iso) return buildDate(Number(iso[1]), Number(iso[2]) - 1, Number(iso[3]));

  const us = text.match(/^(\d{1,2})[/.-](\d{1,2})[/.-](\d{4})$/);
  if (us) return buildDate(Number(us[3]), Number(us[1]) - 1, Number(us[2]));

  const named = text.match(/^([A-Za-z]{3,})\.?\s+(\d{1,2}),?\s+(\d{4})$/);
  if (named) {
    const monthIndex = MONTHS.indexOf(named[1].slice(0, 3).toLowerCase());
    if (monthIndex < 0) return null;
    return buildDate(Number(named[3]), monthIndex, Number(named[2]));
  }

  return null;
}

export function addDays(value, days) {
  const date = toDate(value);
  if (!date) return "";
  date.setDate(date.getDate() + days);
  return toValue(date);
}

export const endsNextDay = (start, end) => !!start && !!end && end < start;

export function isPastStart(date, start, timeZone = null, now = new Date()) {
  if (!date || !start) return false;
  const local = `${date}T${start}`;
  const startsAt = timeZone ? moment.tz(local, timeZone) : moment(local);
  return startsAt.isBefore(now);
}

export function needsPastStartWarning(session, timeZone = null, now = new Date(), trustSavedSessions = true) {
  const unchangedSavedSession = trustSavedSessions && !!session.id && session.saved_date === session.date && session.saved_start === session.start;
  return !unchangedSavedSession && isPastStart(session.date, session.start, timeZone, now);
}

export function closedRegistrationReason({ closesDate, closesTime, sessions, timeZone = null, now = new Date() }) {
  const firstStart = sessions.filter((s) => s.date && s.start).map((s) => `${s.date}T${s.start}`).sort()[0];
  const closes = closesDate && closesTime ? `${closesDate}T${closesTime}` : null;
  const candidates = [closes, firstStart].filter(Boolean);
  if (candidates.length === 0) return null;
  const earliest = candidates.sort()[0];
  const closesAt = timeZone ? moment.tz(earliest, timeZone) : moment(earliest);
  if (closesAt.isAfter(now)) return null;
  return earliest === closes && closes !== firstStart ? "close_time" : "first_session";
}
